import {DetailTable} from '../../../mapping-classes/detail-table';

export class Continents implements DetailTable {
  shieldedText = 'Werelddelen';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(physicalCards: any) {
    if (!physicalCards.continents || physicalCards.continents.lengths === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = physicalCards.continents.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(physicalCards.continents);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen provisie afspraken.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'region',
      'allowedRegion',
      'startDate',
      'endDate',
    ];
  }

  setRowData(continents) {
    continents.forEach((continent) => {
      if (this.restrictedData) {
        continent.percentage = this.shieldedText;
      }
      this.rowData.push(continent);
    });
  }
}
